import VerifyResetPasswordCodeForm from '@features/recovery/verify-reset-password-form/verify-reset-password-form';
export default VerifyResetPasswordCodeForm;
